var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"8f7bd9e44b9d1aca19d2940c9cfbe3edd58791a8"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["frontend-main@flipgive"]={id:"8f7bd9e44b9d1aca19d2940c9cfbe3edd58791a8"};
      